<template>
  <div class="staking-item">
    <van-row class="item-title">
      <van-col :span="12">
        <div class="item-type">
          <div class="type-icon">
            <img :src="safeItem.img" />
          </div>
          <div class="type-name">
            {{ safeItem.coin.title }}
          </div>
        </div>
      </van-col>
      <van-col :span="12" class="txt-right">
        <div class="link-box">
          <span class="link-btn" @click="toPage" style="display: none;">{{
            $t("staking.record")
          }}</span>
        </div>
      </van-col>
    </van-row>
    <div class="staking-item-info">
      <van-row class="item-data">
        <van-col :span="12">
          <p class="data-down">{{ dayval.interest_rate }} %</p>
          {{ $t("staking.getforyear") }}
        </van-col>
        <van-col :span="12" class="txt-right">
          <p>{{ dayval.days }} {{ $t("common.day") }}</p>
          {{ $t("staking.time") }}
        </van-col>
      </van-row>
      <div>
        <ul>
          <li
            v-for="(item, index) in safeItem.staking_info"
            :key="index"
            :class="dayval.id == item.id ? 'selected' : ''"
            @click="changeDay(item)"
          >
            {{ item.days }}
          </li>
        </ul>
      </div>
      <div class="tip">
        {{ $t("staking.snum") }} : {{ dayval.min_price }}
        {{ safeItem.coin.title }}
      </div>
      <van-form @submit="onSubmit" style="margin-top: 20px;">
        <van-field
        type="digit"
          :label="$t('staking.snum')"
          v-model="price"
          :placeholder="$t('staking.snumerror')"
          :rules="[
            {
              required: true,
            },
            {
              validator: validatorprice,
              message: this.$t('staking.snumerror1',{num:  dayval.min_price })
            }
          ]"
        >
        </van-field>
        <van-field v-if="safeWapConfig.traders_password_switch == 1"
          :label="$t('withdrawal.frmtitle2')"
          v-model="pwd"
          type="password"
          :placeholder="$t('withdrawal.frmplaceholder2')"
          :rules="[
            {
              required: true,
            },
          ]"
        >
        </van-field>
        <div style="margin: 30px 16px 16px">
            <van-button native-type="submit" class="web-btn">
              <van-loading v-if="posting" /><span v-else>
                {{ $t("staking.join") }}
              </span>
            </van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "StakingItem",
  props: ["item"],
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
    safeItem() {
      return (
        this.item || {
          coin: {},
        }
      );
    },
  },
  watch: {
    item(newval) {
      this.dayval = newval.staking_info[0];
    },
  },
  data() {
    return {
      dayval: {},
      posting: false,
      pwd: null,
      price: null
    };
  },
  mounted() {
    this.dayval = this.safeItem.staking_info[0];
  },
  methods: {
    validatorprice(val){
      return val >= this.dayval.min_price
    },
    changeDay(val) {
      this.dayval = val;
    },
    toPage() {
      this.$router.push({ name: "staking-list" }, () => {});
    },
    async onSubmit() {
      if(this.posting)return
      this.posting = true
      const frm = {
        id: this.safeItem.id,
        s_id: this.dayval.id,
        amount: this.price,
        paypassword: this.pwd,
      };
      await this.$http({
        method: "post",
        url: "submitStaking",
        data: frm,
      }).then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
          this.price = null
          this.pwd = null
        })
        .catch(() => {
          this.posting = false;
        });
    },
  },
};
</script>

<style>
</style>
